var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 8.25V1.58333C7.91667 1.36232 7.82887 1.15036 7.67259 0.994078C7.51631 0.837797 7.30435 0.75 7.08333 0.75H2.91667C2.69565 0.75 2.48369 0.837797 2.32741 0.994078C2.17113 1.15036 2.08333 1.36232 2.08333 1.58333V8.25M7.91667 8.25H2.08333M7.91667 8.25H8.75M7.91667 8.25H5.83333M2.08333 8.25H1.25M2.08333 8.25H4.16667M5.83333 8.25V6.16667C5.83333 6.05616 5.78943 5.95018 5.71129 5.87204C5.63315 5.7939 5.52717 5.75 5.41667 5.75H4.58333C4.47283 5.75 4.36685 5.7939 4.28871 5.87204C4.21057 5.95018 4.16667 6.05616 4.16667 6.16667V8.25M5.83333 8.25H4.16667M3.75 2.41667H4.16667M3.75 4.08333H4.16667M5.83333 2.41667H6.25M5.83333 4.08333H6.25",
    stroke: "#14674B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOffice);
export default __webpack_public_path__ + "static/media/ic_office.a17bb9393073c8d11dae20f26b968887.svg";
export { ForwardRef as ReactComponent };